import { graphql } from '~/gql'

export const countWhoAndWhatMutation = graphql(`
  mutation CountWhoAndWhat(
    $surveyId: String!
    $perceptionQuestionId: String!
    $keyPointQuestionId: String!
    $liftSaQuestionId: String!
    $brandId: Int!
    $customFilter: CustomFilterInput
  ) {
    countWhoAndWhat(
      surveyId: $surveyId
      perceptionQuestionId: $perceptionQuestionId
      keyPointQuestionId: $keyPointQuestionId
      liftSaQuestionId: $liftSaQuestionId
      brandId: $brandId
      customFilter: $customFilter
    ) {
      awaitId
    }
  }
`)

export const countWhoAndWhatQuery = graphql(`
  query CountWhoAndWhatResult($awaitId: String!) {
    countWhoAndWhat(awaitId: $awaitId) {
      arrived
      result {
        distribution {
          segmentNumber
          count
        }
        perception {
          questionId
          answers {
            answerOption {
              option
              text
            }
            distribution {
              segmentNumber
              count
            }
          }
        }
        keyPoint {
          questionId
          answers {
            answerOption {
              option
              text
            }
            distribution {
              segmentNumber
              count
            }
          }
        }
        riskPotential {
          compare {
            option
            test {
              brandId
              value
            }
          }
          pod {
            option
            score
          }
        }
      }
      error
    }
  }
`)
